// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { MARCAS_API } from "../views/MainLayout/components/shared/services/marcas";
import { makeSetReducer } from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const marcasFullfilledReducer = makeSetReducer(['marcas/fullfilled']);

export const fetchMarcas = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await MARCAS_API.get()
        const data = await response.data;
        dispatch({ type: 'marcas/fullfilled', payload: data })
        const readOnly = JSON.parse(localStorage.getItem('read_only'));
        readOnly.marcas = data;
        localStorage.setItem('read_only', JSON.stringify(readOnly));
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}